// extracted by mini-css-extract-plugin
module.exports = {"icons":"menu-bar_icons__1GxR3","inActiveDelBtn":"menu-bar_inActiveDelBtn__2zdX_","searchInput":"menu-bar_searchInput__2er8o"};